import { BoxSource } from '@profile/src/models';
export const formatType = status => {
  switch (status) {
    case BoxSource.PURCHASE:
      return 'Purchase';

    case BoxSource.OPEN:
      return 'Open';

    case BoxSource.ADMIN:
      return 'Admin';

    case BoxSource.BINANCE_CLAIM:
      return 'Binance Claim';

    default:
      return '';
  }
};